import React from "react";
import { ModeRendererProps } from "./types";

export function ShieldHoneyMode({ brand }: ModeRendererProps) {
  return (
    <g transform="translate(397 540)">
      <clipPath id="clipShield">
        <use href="#shield" />
      </clipPath>
      <g clipPath="url(#clipShield)">
        {Array.from({ length: 18 }).map((_, row) => (
          <g key={row} transform={`translate(0 ${-150 + row * 18})`}>
            {Array.from({ length: 24 }).map((_, col) => {
              const x = -200 + col * 18 + (row % 2 ? 9 : 0);
              const tone = (row + col) % 3 === 0 ? brand.aqua : (row + col) % 3 === 1 ? brand.violet : brand.amber;
              return <polygon key={col} points={`${x},0 ${x + 9},-5 ${x + 18},0 ${x + 9},5`} fill="none" stroke={tone} strokeWidth="1.2" opacity="0.55" />;
            })}
          </g>
        ))}
      </g>
      <use href="#shield" fill="none" stroke={brand.white} strokeWidth="6" />
    </g>
  );
}
